import { Skeleton } from "@/components/ui/skeleton";
import { useResourceById } from "@/hooks/resource-by-id.hook";
import { useResourceLibrary } from "@/hooks/resource-library.hook";
import { cn } from "@/lib/utils";
import { ExportSquare } from "iconsax-react";
import { Download } from "lucide-react";
import { FC, ReactNode } from "react";

type ResourceDetailProps = {
  resourceId: string;
  className?: string;
  children?: ReactNode;
};

const ResourceDetail: FC<ResourceDetailProps> = ({ resourceId, className }) => {
  const { data: resourceLibrary } = useResourceLibrary();

  const {
    data: resource,
    isLoading,
    error,
  } = useResourceById({
    companyId: resourceLibrary?.owner.id || "",
    resourceLibraryId: resourceLibrary?.id || "",
    resourceId: resourceId || "",
  });

  return isLoading ? (
    <Skeleton style={{ width: "100%", height: "24px" }} />
  ) : (
    <>
      {resource && (
        <div className={cn(className)}>
          <div className="text-xs text-muted-foreground">
            {resource.type === "LINK" ? "Enlace" : "Documento"}
          </div>

          <div className="mb-0.5 leading-tight">{resource.name}</div>

          <a
            className="inline-block min-w-0 max-w-full truncate text-sm text-[#4F5D6D] underline"
            href={resource.type === "LINK" ? resource.url : resource.signedUrl}
            target="_blank"
            rel="noreferrer"
          >
            {resource.type === "LINK" ? (
              <>
                <ExportSquare className="mr-1 inline-block" size={12} />
                {resource.url}
              </>
            ) : (
              <>
                <Download className="mr-1 inline-block" size={12} />
                {resource.fileName}
              </>
            )}
          </a>
        </div>
      )}

      {error && <div className={cn(className)}>Error: {error.message}</div>}
    </>
  );
};

export default ResourceDetail;
